import { createSelectors } from '@mri-platform/shared/entity';
import { Mapper } from '../../models';

export const mapperSelectors = createSelectors(Mapper);
